export default "__VITE_ASSET__Bv_5OlsV__"